export type PaginatedResponse<T> = {
  data: T[] | undefined,
  itemCount: number,
  pageCount: number,
}

export class ApiError extends Error {
  code: string;
  description?: string;

  constructor(code: string, message: string, description?: string) {
    super(message);
    this.name = 'HttpError';
    this.code = code;
    this.description = description;
  }
}
